import { useFormik } from 'formik';
import { noop } from 'lodash';
import React, { FunctionComponent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../app/rootReducer';
import {
  filtersSelectors,
  resetValues,
  setValue,
} from '../../store/tables/filtersSlice';

type FilterUserActionsTableFormProps = {
  onCancel: () => void;
};

export const FilterUserActionsTableForm: FunctionComponent<FilterUserActionsTableFormProps> = (
  props
) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { onCancel } = props;

  const filters = useTypedSelector(filtersSelectors.userActions);

  const formik = useFormik({
    initialValues: filters,
    onSubmit: (values) => {
      dispatch(setValue({ table: 'userActions', filters: values }));
      onCancel();
    },
  });

  const handleReset = () => {
    dispatch(resetValues({ table: 'userActions' }));
    formik.resetForm();
  };

  useEffect(() => {
    formik.resetForm({ values: filters });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const isSubmitButtonDisabled = !formik.dirty;

  return (
    <form onSubmit={formik.handleSubmit} className="font-ag2 gray-color-2">
      <div className="form-group row">
        <label htmlFor="context" className="col-sm-4 col-form-label text-break">
          {t('userActions.captions.contextName')}
        </label>
        <div className="col-sm-8 d-flex align-items-center">
          <input
            type="text"
            className="form-control"
            id="context"
            name="context.name"
            value={formik.values.context.name}
            onChange={formik.handleChange}
          />
        </div>
      </div>
      <div className="form-group row">
        <label htmlFor="sender" className="col-sm-4 col-form-label text-break">
          {t('userActions.captions.senderName')}
        </label>
        <div className="col-sm-8 d-flex align-items-center">
          <input
            type="text"
            className="form-control"
            id="sender"
            name="sender.name"
            value={formik.values.sender.name}
            onChange={formik.handleChange}
          />
        </div>
      </div>
      <div className="form-group row justify-content-end mt-4 mb-2">
        <div className="mr-3">
          <button
            type="reset"
            className="btn btn-primary"
            onClick={handleReset}
          >
            {t('common.reset')}
          </button>
          <button
            type="button"
            className="btn btn-secondary mx-1"
            onClick={onCancel}
          >
            {t('common.cancel')}
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={isSubmitButtonDisabled}
          >
            {t('common.apply')}
          </button>
        </div>
      </div>
    </form>
  );
};

FilterUserActionsTableForm.defaultProps = {
  onCancel: noop,
};
